module.exports = __webpack_public_path__ + "static/media/bjelasnica.0ba23652.jpg";